var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuppliers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0747 22.5208C16.2464 22.7917 15.2675 22.9167 14.1191 22.9167H8.47147C7.32311 22.9167 6.34419 22.7917 5.51587 22.5208C5.72295 19.8125 8.23615 17.6771 11.2953 17.6771C14.3544 17.6771 16.8676 19.8125 17.0747 22.5208Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1191 2.08334H8.47148C3.76511 2.08334 1.88257 4.16668 1.88257 9.37501V15.625C1.88257 19.5625 2.95562 21.7188 5.51588 22.5208C5.72296 19.8125 8.23616 17.6771 11.2953 17.6771C14.3544 17.6771 16.8676 19.8125 17.0747 22.5208C19.635 21.7188 20.708 19.5625 20.708 15.625V9.37501C20.708 4.16668 18.8255 2.08334 14.1191 2.08334ZM11.2953 14.7604C9.43158 14.7604 7.92554 13.0834 7.92554 11.0209C7.92554 8.95836 9.43158 7.29168 11.2953 7.29168C13.159 7.29168 14.6651 8.95836 14.6651 11.0209C14.6651 13.0834 13.159 14.7604 11.2953 14.7604Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6651 11.0208C14.6651 13.0833 13.159 14.7604 11.2953 14.7604C9.43158 14.7604 7.92554 13.0833 7.92554 11.0208C7.92554 8.95834 9.43158 7.29166 11.2953 7.29166C13.159 7.29166 14.6651 8.95834 14.6651 11.0208Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliers);
export default __webpack_public_path__ + "static/media/Suppliers.3d350f1545aaca7ca4a6ac0f9a58280f.svg";
export { ForwardRef as ReactComponent };